import { Col, Row } from "antd";
import { Formik } from "formik";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import Card from "shared/components/Card";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { PROCESS_TYPES, TEMPLATES } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import validation from "../validation";

const General = ({ formRef, dirtyRef, setIsDirty, TABS, onSubmit }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const FORM = t("FORM", { returnObjects: true });
  const TEMPLATES_LABELS = t("TEMPLATES", { returnObjects: true });
  const TEMPLATES_THEMES = t("TEMPLATES_THEMES", { returnObjects: true });

  return (
    <Formik
      innerRef={(formik) => {
        formRef.current = formik;
      }}
      initialValues={{
        type: PROCESS_TYPES.B2B,
        name: "",
        theme: null,
        description: "",
      }}
      onSubmit={async (values) => {
        await onSubmit({
          ...values,
          skills: [],
          config: [],
          attributionType: null,
          processStatuses: [],
          insurancePlans: [],
        });
        setIsDirty((prev) => ({ ...prev, [TABS.GENERAL]: false }));
      }}
      validationSchema={validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, {
          returnObjects: true,
        }),
      )}
    >
      {({ values: generalValues, dirty, ...generalFormProps }) => {
        if (dirtyRef.current !== dirty) {
          dirtyRef.current = dirty;
          setIsDirty((prev) => ({ ...prev, [TABS.GENERAL]: dirty }));
        }
        return (
          <Card type="simple" head={false} title={FORM.GENERAL_INFO}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Form>
                  <Col lg={8}>
                    <Input
                      placeholder={FORM.NAME}
                      label={FORM.NAME}
                      {...bindInputProps({
                        name: "name",
                        values: generalValues,
                        ...generalFormProps,
                      })}
                    />
                  </Col>
                  <Col lg={8}>
                    <Select
                      options={Object.keys(TEMPLATES).map((value) => ({
                        label: TEMPLATES_LABELS[value],
                        value,
                      }))}
                      placeholder={FORM.TYPE}
                      label={FORM.TYPE}
                      {...bindInputProps({
                        name: "type",
                        values: generalValues,
                        ...generalFormProps,
                      })}
                    />
                  </Col>
                  <Col lg={8}>
                    <Select
                      options={Object.keys(
                        get(
                          TEMPLATES[get(generalValues, "type")],
                          "THEMES",
                          {},
                        ),
                      ).map((key) => ({
                        label: TEMPLATES_THEMES[key],
                        value: key,
                      }))}
                      placeholder={FORM.THEME}
                      label={FORM.THEME}
                      {...bindInputProps({
                        name: "theme",
                        values: generalValues,
                        ...generalFormProps,
                      })}
                    />
                  </Col>
                  <Col lg={12}>
                    <Input
                      placeholder={FORM.DESCRIPTION}
                      label={FORM.DESCRIPTION}
                      {...bindInputProps({
                        name: "description",
                        values: generalValues,
                        ...generalFormProps,
                      })}
                    />
                  </Col>
                </Form>
              </Col>
            </Row>
          </Card>
        );
      }}
    </Formik>
  );
};

export default General;
